import { Box, Button, Result } from '@aicon-dev/caas-ui';

import { Link } from '~/router';

export default function NotFound() {
  return (
    <Box
      display="flex"
      justify="center"
      align="center"
      style={{
        height: '100dvh',
      }}
    >
      <Result
        size="medium"
        status="error"
        icon={<Box color="primary.500">404</Box>}
        title="페이지를 찾을 수 없습니다."
      >
        <Button asChild color="primary" variant="filled">
          <Link to="/">홈으로</Link>
        </Button>
      </Result>
    </Box>
  );
}
